<div class="dashboard">
  <coa-dashboard-header
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-header">
  </coa-dashboard-header>

  <coa-dashboard-summary
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-summary">
  </coa-dashboard-summary>

  <coa-dashboard-offline-traffic
    [categoryId]="categoryId"
    [clientId]="clientId"
    [timePeriod]="dateRange"
    class="dashboard-offline-traffic"
    data-cy="dashboard.offline-traffic">
  </coa-dashboard-offline-traffic>

  <coa-dashboard-groups
    *ngIf="groupsFeatureToggle$ | async"
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-groups">
  </coa-dashboard-groups>

  <coa-dashboard-floors
    *ngIf="floorsFeatureToggle$ | async"
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-floors"
    data-cy="dashboard.floors">
  </coa-dashboard-floors>

  <coa-dashboard-location-preferences
    *ngIf="locationPreferencesFeatureToggle$ | async"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-location-preferences">
  </coa-dashboard-location-preferences>
</div>

